import React from 'react';

import Close from '../icons/General/Close';
import Delete from '../icons/General/Delete';
import Edit from '../icons/General/Edit';
import Suspend from '../icons/General/Suspend';
import TurnOn from '../icons/General/TurnOn';
import Check from '../icons/TablesMenu/Check';

import IconButton, {IIconButtonProps} from './IconButton';

type IconComponent = React.FC<{width?: number | string, height?: number | string}>;

export type IPresetIconButtonProps = Omit<IIconButtonProps, 'icon'> & {
    iconSize?: number;
};

const createIconButton = (Icon: IconComponent, displayName: string) => {
    const PresetIconButton: React.FC<IPresetIconButtonProps> = ({iconSize, ...props}) => (
        <IconButton icon={<Icon width={iconSize} height={iconSize}/>} {...props}/>
    );
    PresetIconButton.displayName = displayName;
    return PresetIconButton;
};

export const CloseButton = createIconButton(Close, 'CloseButton');
export const DeleteButton = createIconButton(Delete, 'DeleteButton');
export const EditButton = createIconButton(Edit, 'EditButton');
export const PauseButton = createIconButton(Suspend, 'PauseButton');
export const PlayButton = createIconButton(TurnOn, 'PlayButton');
export const CheckButton = createIconButton(Check, 'CheckButton');
